import styled, { css } from "styled-components";
import { Arrow } from '../Button/style'

export const TextButton = styled.button.attrs(props => ({ type: 'button' }))`
  position: relative;
  width: 421px;
  height: 70px;
  padding: .5rem;
  font-family: "Avenir Next Regular", sans-serif;
  font-size: 28px;
  line-height: 38px;
  color: #fff;
  background-color: transparent;
  border: none;
  transition: .2s ease-in-out;
  :hover {
    background-color: #ea3639;
    cursor: pointer;
    border-radius: 2px;
  }
  :active {
    background-color: #ec080b;
  }
  ${({theme}) => css`
    ${theme.media.tablet} {
      width: 100%;
    }
  `}
`;

export const ArrowLeft = styled.svg`
  margin-right: 10px;
  stroke: white;  
`;